import { render, staticRenderFns } from "./Tesis.vue?vue&type=template&id=484597f1&scoped=true"
import script from "./Tesis.vue?vue&type=script&lang=js"
export * from "./Tesis.vue?vue&type=script&lang=js"
import style0 from "./Tesis.vue?vue&type=style&index=0&id=484597f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484597f1",
  null
  
)

export default component.exports